// src/components/NotFound.js
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <Container className="text-center py-5">
            <Row>
                <Col>
                    <p className="big-title fw-bold text-primary">404</p>
                    <p className="lead fw-bold text-primary">Oops! Page Not Found.</p>
                    {/* <div className="error-img-block">
                        <img src={errorImg} alt="404-error" className="img-fluid" loading="lazy" />
                    </div> */}
                    <Button variant="primary" onClick={handleGoHome}>Go Home</Button>
                </Col>
            </Row>
        </Container>
    );
};

export default NotFound;
